import { apiSlice } from "../api/apiSlice";

export const dialogsSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDialogs: builder.query({
      query: () => `/my/dialogs`,
      providesTags: (result, error, arg) => [{ type: "Dialog" }],
      keepUnusedDataFor: 300,
    }),
    getDialog: builder.query({
      query: ({ dialogId, from = 0 }) => `/my/dialogs/${dialogId}?from=${from}`,
      providesTags: (result, error, arg) => [
        { type: "Dialog", id: `${arg?.dialogId}-${arg?.from}` },
      ],
    }),
    getScore: builder.query({
      query: ({ dialogId, from = 0 }) => `/my/dialogs/${dialogId}/score`,
      providesTags: (result, error, arg) => [
        { type: "Score", id: `${arg?.dialogId}` },
      ],
    }),
    postDialog: builder.mutation({
      query: ({ body }) => {
        return {
          url: `/my/dialogs`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: [{ type: "Dialog" }],
    }),
    getFollowUp: builder.query({
      query: ({ dialogId }) => `/my/dialogs/${dialogId}/followup`,
      providesTags: (result, error, arg) => [
        { type: "Followup", id: `${arg?.dialogId}` },
      ],
    }),
    postFollowUp: builder.mutation({
      query: ({ dialogId, followUp }) => {
        return {
          url: `/my/dialogs/${dialogId}/${followUp}`,
          method: "POST",
          body: {},
        };
      },
    }),
    postMessage: builder.mutation({
      query: ({ params, body }) => {
        return {
          url: `/my/dialogs/${params?.dialogId}/messages`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: (result, error, arg) => [
        { type: "Message" },
        {
          type: "Message",
          id: `${arg?.params?.dialogId}`,
        },
      ],
    }),
  }),
});

export const {
  useGetDialogsQuery,
  useGetDialogQuery,
  useGetFollowUpQuery,
  useGetScoreQuery,
  usePostFollowUpMutation,
  usePostDialogMutation,
  usePostMessageMutation,
} = dialogsSlice;
